var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g3, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 173,
    viewBox: "0 0 178 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77.6674 159.809C95.345 159.809 109.676 145.478 109.676 127.801C109.676 110.123 95.345 95.7926 77.6674 95.7926C59.9897 95.7926 45.6592 110.123 45.6592 127.801C45.6592 145.478 59.9897 159.809 77.6674 159.809Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6672 158.959C94.9722 158.959 109.001 144.931 109.001 127.626C109.001 110.321 94.9722 96.2926 77.6672 96.2926C60.3622 96.2926 46.3337 110.321 46.3337 127.626C46.3337 144.931 60.3622 158.959 77.6672 158.959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4383 127.905C65.4383 127.905 61.8851 145.406 59.9469 144.437C59.9469 144.437 78.6465 160.589 95.1566 144.437C95.1566 144.437 92.2494 132.104 88.0501 127.905H65.4383Z",
    fill: "#524CB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7546 159.053C83.8771 159.063 89.8671 157.271 94.9778 153.899C93.8233 147.59 89.4296 147.23 89.4296 147.23H65.2027C65.2027 147.23 61.0564 147.57 59.7614 153.375C65.0289 157.08 71.3144 159.064 77.7546 159.053Z",
    fill: "#524CB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.426 140.826C85.0972 140.826 91.3161 134.607 91.3161 126.936C91.3161 119.265 85.0972 113.046 77.426 113.046C69.7547 113.046 63.5359 119.265 63.5359 126.936C63.5359 134.607 69.7547 140.826 77.426 140.826Z",
    fill: "#524CB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.545 139.533H82.2358V147.556C82.2358 148.769 81.7538 149.933 80.8958 150.791C80.0377 151.649 78.874 152.131 77.6606 152.131H77.1202C75.9068 152.131 74.7431 151.649 73.8851 150.791C73.0271 149.933 72.545 148.769 72.545 147.556V139.533Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4179 139.174H81.3629C81.5944 139.174 81.8165 139.266 81.9802 139.43C82.1438 139.593 82.2358 139.815 82.2358 140.047V147.197C82.2358 148.41 81.7538 149.574 80.8958 150.432C80.0378 151.29 78.874 151.772 77.6606 151.772H77.1202C75.9068 151.772 74.7431 151.29 73.8851 150.432C73.0271 149.574 72.545 148.41 72.545 147.197V140.047C72.545 139.815 72.637 139.593 72.8007 139.43C72.9644 139.266 73.1864 139.174 73.4179 139.174H73.4179Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M72.563 143.192C75.6862 144.359 79.1241 144.369 82.2537 143.219V142.028H72.563V143.192Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.426 143.841C85.0972 143.841 91.3161 137.622 91.3161 129.951C91.3161 122.28 85.0972 116.061 77.426 116.061C69.7547 116.061 63.5359 122.28 63.5359 129.951C63.5359 137.622 69.7547 143.841 77.426 143.841Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1465 124.675H90.6346C90.6346 124.675 88.3734 113.979 78.3596 114.661C68.3458 115.343 64.1465 124.675 64.1465 124.675Z",
    fill: "#524CB3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8231 131.781C64.5367 131.781 65.1152 130.697 65.1152 129.359C65.1152 128.021 64.5367 126.936 63.8231 126.936C63.1095 126.936 62.531 128.021 62.531 129.359C62.531 130.697 63.1095 131.781 63.8231 131.781Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9575 131.781C91.6711 131.781 92.2496 130.697 92.2496 129.359C92.2496 128.021 91.6711 126.936 90.9575 126.936C90.2439 126.936 89.6654 128.021 89.6654 129.359C89.6654 130.697 90.2439 131.781 90.9575 131.781Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6672 98.6267C83.4373 98.6267 89.0779 100.338 93.8755 103.543C98.6732 106.749 102.413 111.306 104.621 116.636C106.829 121.967 107.407 127.833 106.281 133.492C105.155 139.152 102.377 144.35 98.2965 148.43C94.2164 152.51 89.018 155.289 83.3588 156.414C77.6996 157.54 71.8336 156.962 66.5027 154.754C61.1718 152.546 56.6155 148.807 53.4098 144.009C50.2041 139.211 48.493 133.571 48.493 127.801C48.493 123.97 49.2477 120.176 50.7138 116.636C52.1799 113.097 54.3289 109.881 57.038 107.172C59.747 104.463 62.9632 102.314 66.5027 100.847C70.0423 99.3813 73.836 98.6267 77.6672 98.6267ZM77.6672 91.422C70.4722 91.422 63.4387 93.5556 57.4562 97.5529C51.4737 101.55 46.8109 107.232 44.0575 113.879C41.3041 120.527 40.5837 127.841 41.9874 134.898C43.391 141.955 46.8558 148.437 51.9435 153.525C57.0312 158.612 63.5133 162.077 70.5701 163.481C77.6269 164.884 84.9414 164.164 91.5888 161.411C98.2362 158.657 103.918 153.994 107.915 148.012C111.912 142.029 114.046 134.996 114.046 127.801C114.035 118.156 110.199 108.909 103.379 102.089C96.5589 95.2692 87.3121 91.4329 77.6672 91.422Z",
    fill: "#524CB3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8088 82.9175H72.281V91.8942H80.8088V82.9175Z",
    fill: "#524CB3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0174 86.5543L91.394 94.2488L98.7038 98.6409L103.327 90.9464L96.0174 86.5543Z",
    fill: "#524CB3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.182 101.255L106.331 105.607L110.466 113.066L118.317 108.714L114.182 101.255Z",
    fill: "#524CB3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.975 142.111L106.456 149.343L114.068 154.1L118.587 146.868L110.975 142.111Z",
    fill: "#524CB3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1523 101.256L37.0179 108.714L44.8691 113.066L49.0035 105.607L41.1523 101.256Z",
    fill: "#524CB3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.36 142.111L36.7473 146.868L41.2664 154.1L48.879 149.343L44.36 142.111Z",
    fill: "#524CB3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3169 86.5543L52.0071 90.9464L56.6304 98.6409L63.9402 94.2488L59.3169 86.5543Z",
    fill: "#524CB3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8088 163.708H72.281V172.684H80.8088V163.708Z",
    fill: "#524CB3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7038 156.961L91.394 161.353L96.0174 169.047L103.327 164.655L98.7038 156.961Z",
    fill: "#524CB3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6304 156.961L52.0071 164.655L59.3169 169.047L63.9402 161.353L56.6304 156.961Z",
    fill: "#524CB3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2094 124.21H31.8862V131.84H42.2094V124.21Z",
    fill: "#524CB3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.125 131.84H123.448V124.21H113.125V131.84Z",
    fill: "#524CB3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.781 90.8914C149.459 90.8914 163.789 76.5609 163.789 58.8832C163.789 41.2056 149.459 26.875 131.781 26.875C114.104 26.875 99.7729 41.2056 99.7729 58.8832C99.7729 76.5609 114.104 90.8914 131.781 90.8914Z",
    fill: "url(#paint1_linear)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131.843 90.0122C149.148 90.0122 163.177 75.9838 163.177 58.6788C163.177 41.3738 149.148 27.3453 131.843 27.3453C114.538 27.3453 100.51 41.3738 100.51 58.6788C100.51 75.9838 114.538 90.0122 131.843 90.0122Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131.869 90.1359C137.991 90.1457 143.981 88.3531 149.092 84.9817C147.937 78.6719 143.544 78.3121 143.544 78.3121H119.317C119.317 78.3121 115.171 78.6526 113.875 84.457C119.143 88.1623 125.429 90.146 131.869 90.1359Z",
    fill: "#524CB3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.54 73.1424C139.893 73.1424 146.664 66.3711 146.664 58.0184C146.664 49.6656 139.893 42.8944 131.54 42.8944C123.187 42.8944 116.416 49.6656 116.416 58.0184C116.416 66.3711 123.187 73.1424 131.54 73.1424Z",
    fill: "#524CB3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.659 70.6154H136.35V78.6382C136.35 79.8516 135.868 81.0153 135.01 81.8733C134.152 82.7313 132.988 83.2133 131.774 83.2133H131.234C130.021 83.2133 128.857 82.7313 127.999 81.8733C127.141 81.0153 126.659 79.8516 126.659 78.6382V70.6154Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M127.532 70.2565H135.477C135.708 70.2565 135.93 70.3484 136.094 70.5121C136.258 70.6758 136.35 70.8978 136.35 71.1293V78.2793C136.35 79.4927 135.868 80.6564 135.01 81.5144C134.152 82.3724 132.988 82.8544 131.774 82.8544H131.234C130.021 82.8544 128.857 82.3724 127.999 81.5144C127.141 80.6564 126.659 79.4927 126.659 78.2793V71.1293C126.659 70.8978 126.751 70.6758 126.914 70.5121C127.078 70.3484 127.3 70.2565 127.532 70.2565Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.677 74.2745C129.8 75.4414 133.238 75.4509 136.368 74.3013V73.1108H126.677V74.2745Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M131.54 74.9235C139.211 74.9235 145.43 68.7047 145.43 61.0334C145.43 53.3621 139.211 47.1433 131.54 47.1433C123.869 47.1433 117.65 53.3621 117.65 61.0334C117.65 68.7047 123.869 74.9235 131.54 74.9235Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.646 48.3988C121.646 48.3988 127.5 60.2812 144.013 53.3789L140.169 47.3503L133.354 44.9039L121.646 48.3988Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.646 48.2241C121.646 48.2241 127.5 60.1065 144.013 53.2042L140.169 47.1756L133.354 44.7292L121.646 48.2241Z",
    fill: "#524CB3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.594 47.4213C121.989 46.1994 122.671 45.09 123.583 44.1863C126.316 41.4856 130.794 40.9154 133.092 37.8359C133.217 38.0538 133.295 38.2955 133.321 38.5453C133.347 38.7952 133.32 39.0478 133.243 39.2867C133.165 39.5256 133.038 39.7457 132.87 39.9326C132.703 40.1195 132.497 40.2692 132.268 40.372C134.466 40.3578 137.02 40.1651 138.264 38.3528C138.572 39.0688 138.67 39.8575 138.547 40.6271C138.424 41.3967 138.085 42.1156 137.57 42.7002C139.521 42.7888 141.603 44.1128 141.729 46.0618C141.813 47.3601 140.999 48.5894 139.932 49.334C138.823 50.0222 137.59 50.4864 136.303 50.7006C132.594 51.5183 119.174 54.9458 121.594 47.4213Z",
    fill: "#524CB3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.43 61.1549H145.061L137.897 67.533C130.995 64.3003 125.927 67.533 125.927 67.533L118.413 61.417L117.656 61.5122C117.758 65.1578 119.291 68.6166 121.922 71.142C124.553 73.6673 128.072 75.0565 131.719 75.0096C135.365 74.9627 138.847 73.4834 141.413 70.8912C143.978 68.299 145.421 64.8019 145.43 61.1549V61.1549ZM131.519 69.9793C128.817 69.9793 126.626 69.4317 126.626 68.7562C126.626 68.0806 128.817 67.533 131.519 67.533C134.221 67.533 136.412 68.0806 136.412 68.7562C136.412 69.4317 134.221 69.9793 131.519 69.9793Z",
    fill: "#524CB3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.645 63.4428C118.358 63.4428 118.937 62.3581 118.937 61.0201C118.937 59.6821 118.358 58.5974 117.645 58.5974C116.931 58.5974 116.353 59.6821 116.353 61.0201C116.353 62.3581 116.931 63.4428 117.645 63.4428Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.428 63.4428C146.142 63.4428 146.72 62.3581 146.72 61.0201C146.72 59.6821 146.142 58.5974 145.428 58.5974C144.715 58.5974 144.136 59.6821 144.136 61.0201C144.136 62.3581 144.715 63.4428 145.428 63.4428Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M131.781 29.7091C137.551 29.7091 143.192 31.4201 147.99 34.6258C152.787 37.8315 156.527 42.3879 158.735 47.7188C160.943 53.0496 161.521 58.9156 160.395 64.5748C159.269 70.2341 156.491 75.4324 152.411 79.5125C148.33 83.5926 143.132 86.3712 137.473 87.4969C131.814 88.6226 125.948 88.0448 120.617 85.8367C115.286 83.6286 110.73 79.8892 107.524 75.0916C104.318 70.2939 102.607 64.6534 102.607 58.8833C102.607 51.1458 105.681 43.7252 111.152 38.254C116.623 32.7828 124.044 29.7091 131.781 29.7091ZM131.781 22.5044C124.586 22.5044 117.553 24.638 111.57 28.6353C105.588 32.6327 100.925 38.3143 98.1716 44.9617C95.4181 51.609 94.6977 58.9236 96.1014 65.9804C97.505 73.0372 100.97 79.5193 106.057 84.607C111.145 89.6947 117.627 93.1594 124.684 94.5631C131.741 95.9668 139.055 95.2464 145.703 92.4929C152.35 89.7395 158.032 85.0768 162.029 79.0943C166.027 73.1118 168.16 66.0783 168.16 58.8833C168.149 49.2383 164.313 39.9916 157.493 33.1716C150.673 26.3516 141.426 22.5153 131.781 22.5044Z",
    fill: "#524CB3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.923 14H126.395V22.9767H134.923V14Z",
    fill: "#524CB3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M150.131 17.6367L145.508 25.3312L152.818 29.7233L157.441 22.0288L150.131 17.6367Z",
    fill: "#524CB3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M168.296 32.3378L160.445 36.6898L164.579 44.1484L172.431 39.7965L168.296 32.3378Z",
    fill: "#524CB3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M165.088 73.1938L160.569 80.4258L168.182 85.1827L172.701 77.9507L165.088 73.1938Z",
    fill: "#524CB3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2661 32.3379L91.1317 39.7965L98.9829 44.1485L103.117 36.6899L95.2661 32.3379Z",
    fill: "#524CB3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.474 73.1938L90.8613 77.9507L95.3804 85.1827L102.993 80.4258L98.474 73.1938Z",
    fill: "#524CB3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M113.431 17.6368L106.121 22.0289L110.745 29.7234L118.054 25.3313L113.431 17.6368Z",
    fill: "#524CB3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M134.923 94.7899H126.395V103.767H134.923V94.7899Z",
    fill: "#524CB3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M152.819 88.0426L145.509 92.4348L150.133 100.129L157.442 95.7372L152.819 88.0426Z",
    fill: "#524CB3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M110.745 88.0432L106.121 95.7377L113.431 100.13L118.054 92.4353L110.745 88.0432Z",
    fill: "#524CB3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3232 55.2926H86V62.9228H96.3232V55.2926Z",
    fill: "#524CB3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M167.239 62.9227H177.562V55.2926H167.239V62.9227Z",
    fill: "#524CB3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.8856 77.0123C63.5633 77.0123 77.8939 62.6818 77.8939 45.0041C77.8939 27.3265 63.5633 12.9959 45.8856 12.9959C28.208 12.9959 13.8774 27.3265 13.8774 45.0041C13.8774 62.6818 28.208 77.0123 45.8856 77.0123Z",
    fill: "url(#paint2_linear)"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9481 76.133C63.2531 76.133 77.2815 62.1046 77.2815 44.7996C77.2815 27.4946 63.2531 13.4661 45.9481 13.4661C28.6431 13.4661 14.6146 27.4946 14.6146 44.7996C14.6146 62.1046 28.6431 76.133 45.9481 76.133Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1851 47.8874C63.1851 58.3101 55.6962 63.4394 45.9731 63.4394C36.25 63.4394 27.9747 58.3101 27.9747 47.8874C27.9747 37.4646 35.8568 29.0153 45.5799 29.0153C55.303 29.0153 63.1851 37.4646 63.1851 47.8874Z",
    fill: "#524CB3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.973 76.2568C52.0955 76.2666 58.0855 74.474 63.1962 71.1026C62.0416 64.7928 57.648 64.433 57.648 64.433H33.4211C33.4211 64.433 29.2748 64.7735 27.9797 70.5779C33.2473 74.2832 39.5328 76.2669 45.973 76.2568Z",
    fill: "#524CB3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.7633 56.7363H50.4541V64.7591C50.4541 65.9725 49.972 67.1362 49.114 67.9942C48.256 68.8522 47.0923 69.3342 45.8789 69.3342H45.3385C44.1251 69.3342 42.9614 68.8522 42.1034 67.9942C41.2453 67.1362 40.7633 65.9725 40.7633 64.7591V56.7363H40.7633Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6362 56.3774H49.5812C49.8127 56.3774 50.0347 56.4694 50.1984 56.633C50.3621 56.7967 50.4541 57.0188 50.4541 57.2502V64.4002C50.4541 65.6136 49.972 66.7773 49.114 67.6353C48.256 68.4934 47.0923 68.9754 45.8789 68.9754H45.3385C44.1251 68.9754 42.9614 68.4934 42.1033 67.6353C41.2453 66.7773 40.7633 65.6136 40.7633 64.4002V57.2502C40.7633 57.0187 40.8553 56.7967 41.019 56.633C41.1827 56.4693 41.4047 56.3774 41.6362 56.3774V56.3774Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.7811 60.3954C43.9043 61.5624 47.3423 61.5719 50.4719 60.4222V59.2318H40.7811V60.3954Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6448 61.0443C53.3161 61.0443 59.5349 54.8255 59.5349 47.1542C59.5349 39.4829 53.3161 33.2641 45.6448 33.2641C37.9736 33.2641 31.7548 39.4829 31.7548 47.1542C31.7548 54.8255 37.9736 61.0443 45.6448 61.0443Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.6346 48.0621C29.6346 48.0621 38.2844 47.0137 44.8371 38.6261C44.8371 38.6261 53.4868 48.1495 59.5154 47.1011C59.5154 47.1011 63.0102 43.4315 59.5154 39.7619C56.0206 36.0924 53.3121 31.4617 48.6814 32.0733C44.0508 32.6849 38.3717 32.947 35.9254 35.1313C33.479 37.3155 29.6346 48.0621 29.6346 48.0621Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6346 47.8874C29.6346 47.8874 38.2844 46.839 44.8371 38.4514C44.8371 38.4514 53.4868 47.9748 59.5154 46.9264C59.5154 46.9264 63.0102 43.2568 59.5154 39.5872C56.0206 35.9177 53.3121 31.287 48.6814 31.8986C44.0508 32.5102 38.3717 32.7723 35.9254 34.9566C33.479 37.1409 29.6346 47.8874 29.6346 47.8874Z",
    fill: "#524CB3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7492 49.5637C32.4629 49.5637 33.0414 48.479 33.0414 47.141C33.0414 45.803 32.4629 44.7183 31.7492 44.7183C31.0356 44.7183 30.4572 45.803 30.4572 47.141C30.4572 48.479 31.0356 49.5637 31.7492 49.5637Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59.533 49.5637C60.2466 49.5637 60.825 48.479 60.825 47.141C60.825 45.803 60.2466 44.7183 59.533 44.7183C58.8193 44.7183 58.2408 45.803 58.2408 47.141C58.2408 48.479 58.8193 49.5637 59.533 49.5637Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8753 15.8686C46.2178 15.8686 46.5613 15.8745 46.9058 15.8865C54.5493 16.1521 61.7828 19.4086 67.049 24.9547C72.3152 30.5009 75.1929 37.8933 75.0626 45.5402C74.9323 53.1872 71.8045 60.4772 66.3524 65.8408C60.9003 71.2043 53.56 74.2125 45.912 74.2176C45.5695 74.2176 45.226 74.2116 44.8815 74.1997C37.238 73.934 30.0045 70.6776 24.7383 65.1314C19.4721 59.5852 16.5944 52.1929 16.7246 44.5459C16.8549 36.899 19.9828 29.6089 25.4349 24.2454C30.887 18.8818 38.2272 15.8737 45.8753 15.8686ZM45.8775 8.66388V15.8686L45.8769 8.66388C36.3394 8.66832 27.185 12.4181 20.385 19.1057C13.5851 25.7934 9.68338 34.884 9.52011 44.4201C9.35683 53.9563 12.945 63.1751 19.5121 70.0916C26.0791 77.0082 35.0997 81.0691 44.6315 81.4C45.057 81.4148 45.4877 81.4223 45.9119 81.4223C55.4493 81.4175 64.6034 77.6674 71.4031 70.9797C78.2028 64.2919 82.1042 55.2013 82.2673 45.6653C82.4304 36.1292 78.8421 26.9106 72.275 19.9942C65.708 13.0778 56.6874 9.01702 47.1558 8.68612C46.7303 8.67136 46.3003 8.66388 45.8775 8.66388Z",
    fill: "#524CB3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0682 -1.57124e-05L41.7567 8.97125L50.2794 9.26712L50.5909 0.295852L42.0682 -1.57124e-05Z",
    fill: "#524CB3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6645 4.45877L60.777 11.9882L67.93 16.6314L72.8175 9.10192L65.6645 4.45877Z",
    fill: "#524CB3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3075 19.7806L75.3101 23.8576L79.1832 31.4552L87.1806 27.3782L83.3075 19.7806Z",
    fill: "#524CB3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6841 60.5006L73.9169 67.5715L81.3599 72.5896L86.1271 65.5188L78.6841 60.5006Z",
    fill: "#524CB3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 17.2468L5.93066 24.5574L13.6261 29.1792L18.0168 21.8685L10.3213 17.2468Z",
    fill: "#524CB3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1095 58.1893L4.33643 62.6793L8.60186 70.0637L16.375 65.5738L12.1095 58.1893Z",
    fill: "#524CB3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9852 3.18474L21.5275 7.32065L25.8811 15.1709L33.3388 11.035L28.9852 3.18474Z",
    fill: "#524CB3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2649 80.7413L38.9535 89.7126L47.4762 90.0085L47.7876 81.0372L39.2649 80.7413Z",
    fill: "#524CB3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9059 74.9153L58.4481 79.0512L62.8017 86.9015L70.2595 82.7656L65.9059 74.9153Z",
    fill: "#524CB3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8576 73.4556L18.9701 80.985L26.1231 85.6282L31.0106 78.0987L23.8576 73.4556Z",
    fill: "#524CB3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5817 40.2244L0.264771 39.8663L4.64894e-05 47.4919L10.317 47.85L10.5817 40.2244Z",
    fill: "#524CB3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M81.19 50.3104L91.507 50.6685L91.7717 43.0429L81.4547 42.6848L81.19 50.3104Z",
    fill: "#524CB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29745.8,
    y1: 20005.8,
    x2: 29745.8,
    y2: 10336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 40037.3,
    y1: 12004.6,
    x2: 40037.3,
    y2: 2334.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 45.8856,
    y1: 77.0123,
    x2: 45.8856,
    y2: 12.9959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon4);
export default __webpack_public_path__ + "static/media/about-icon4.9de0d6d766f68a24da4d90aaefa19fdc.svg";
export { ForwardRef as ReactComponent };